import React, { useEffect, useState } from 'react';
import { Form, FormInstance, SelectBooleanInput } from 'blueprint-form';

import { CardBlock } from '../../card';
import { LoadingBlock } from '../../loading/progress';
import Modal from '../../modal';
import Toast from '../../toast';
import Callout from '../../callout';

import { Col, Row } from '../../../../grid';
import Button from '../../../molecules/button';
import Icon from '../../../atoms/icon';
import { faSave } from '@fortawesome/pro-solid-svg-icons';
import { ConfigComponent } from '../../../../libs/apps';
import { PostJSON, BaseResponse } from '../../../../libs/request';
import { useTerms } from '../../../../contexts/terms';
import { useGetAccountSettings } from '../../../../libs/account';

interface GenericConfigFormData {
  flag: boolean;
}

/**
 * Composer Program Configuration Form
 *
 * @returns JSX.Element
 */
export const GenericConfigForm: ConfigComponent = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [settings, setSettings] = useState<GenericConfigFormData>(null);
  const { terms } = useTerms();
  const { settings: existingSettings, isLoading: isDataLoading } =
    useGetAccountSettings();
  const flag = 'flag';
  let initialValue = false;
  if (existingSettings) {
    initialValue = existingSettings[flag];
  }
  const initialFormData = {
    flag: initialValue
  };
  const form = new FormInstance<GenericConfigFormData>(initialFormData);

  // Fill in form with updated settings
  useEffect(() => {
    form.setData(settings);
  }, [settings]);

  /**
   * Save account settings
   */
  const onSubmit = (data: GenericConfigFormData) => {
    const params = {
      flag: data.flag
    };
    setIsLoading(true);
    PostJSON<BaseResponse>({
      url: '/user/edit_account_settings/',
      params
    }).then((response) => {
      setIsLoading(false);
      if (response.status !== 'OK') {
        Modal.error({
          title: 'Error Saving Settings',
          content: response.message
        });
        return;
      }
      Toast({
        intent: 'success',
        message: 'The settings have been saved successfully!'
      });
      setSettings(data);
    });
  };

  if (isLoading) {
    return <LoadingBlock />;
  }

  return isDataLoading || isLoading ? null : (
    <Form form={form} onSubmit={onSubmit}>
      <>
        <CardBlock>
          <Row>
            <Col sm={24}>
              <SelectBooleanInput label="Flag" name={'flag'} fill />
              <Callout>
                Turning this on will edit the messaging sent to{' '}
                {terms.patient.plural}.
              </Callout>
            </Col>
          </Row>
          <Row className="mt-7">
            <Col sm={8}>
              <Button
                type="submit"
                icon={<Icon icon={faSave} />}
                intent="primary"
                fill
              >
                Save
              </Button>
            </Col>
          </Row>
        </CardBlock>
      </>
    </Form>
  );
};
